import { WorkersPoolItem } from 'ogp/services/workers-pool-service.types';
import { ExternalFlexPoolsTableColumnDefinition } from './external-flex-pools-table.types';

export const getExternalFlexPoolsTableData = (
  data: WorkersPoolItem[]
): ExternalFlexPoolsTableColumnDefinition[] => {
  return data.map((item) => ({
    id: item.id,
    flexPoolName: item.name,
    serviceAgreementNames: item.serviceAgreements.map((sa) => sa.name),
    activeWorkersCount: item.activeWorkersCount,
  }));
};
